import React from 'react';
import { all, takeEvery, put } from 'redux-saga/effects';
import * as notifications from 'react-notification-system-redux';
import fp from 'lodash/fp';

const actions = [];

const generateTitle = title => (
    title && title.length > 0 ? title.charAt(0).toUpperCase() + title.slice(1) : ''
);

export function* logger(action) {
    const handler = actions.find(a => action.type === a.actionType);
    if (handler && handler.notificationType) {
        let key = 0;
        yield put(notifications[handler.notificationType]({
            title: generateTitle(handler.notificationType),
            position: 'tc',
            autoDismiss: 0,
            children: (
                <div>{fp.flow(
                    fp.split('\n'),
                    // eslint-disable-next-line no-plusplus
                    fp.map(line => <React.Fragment key={ key++ }>{line}<br /></React.Fragment>)
                )(handler.messageGenerator(action.error))}
                </div>
            )
        }));
        // eslint-disable-next-line no-console
        console.warn(handler.messageGenerator(action.error));
    }
}

function isFetchError(action) {
    return actions.find(a => action.type === a.actionType);
}

export const subscribe = (actionType, title, notificationType, messageGenerator = fp.identity) => {
    if (actionType && typeof (actionType) === 'string') {
        const subscription = {
            actionType, title, messageGenerator, notificationType
        };
        actions.push(subscription);
        return subscription;
    }

    return null;
};

export const unsubscribe = (subscription) => {
    const index = actions.indexOf(subscription);
    if (index !== -1) {
        actions.splice(index, 1);
        return true;
    }

    return false;
};

export const clearSubscriptions = () => {
    actions.splice(0, actions.length);
};

export default function* rootSaga() {
    yield all([
        takeEvery(action => isFetchError(action), logger)
    ]);
}
